
import { useEffect } from "react";
import { forceFullCacheClear } from "./utils/cacheUtils";

export const useCacheInit = () => {
  useEffect(() => {
    console.log("Blog logic hook initialized - ensuring cache is completely cleared for fresh data");
    // Use the more aggressive cache clearing function
    forceFullCacheClear();
  }, []);
};
